import axios from "axios";
export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async createQuizAnswer( _, formData){
      return await axios.post('/employee/quizzes', formData )
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
  },
};